import React, {useEffect, useState} from "react";
import { Redirect} from "react-router-dom";
import API from "../../helpers/apiHelpers";
import {RootState, useAppDispatch} from "../../redux/store";
import {LoginPage} from "../index";
import {getUserProfile} from "../../redux/userProfile/userProfile.actions";
import {useLocation} from "react-router";
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const IsLoggedInCheck: React.FC = () => {
    const dispatch = useAppDispatch();
    const [isConfirmed, setIsConfirmed] = useState(false);

    useEffect(() => {
        const auth = JSON.parse(localStorage.getItem("auth"));
        console.log(API.isLoggedIn);
        if(auth) {
            //@ts-ignore
            if (new Date(auth.expiresAt) < new Date()) {
                localStorage.removeItem("auth");
                localStorage.removeItem("profile");
                return
            }
            dispatch(getUserProfile({userId: auth.userId}))
                .then(()=> {
                    setIsConfirmed(true)
                    API.isLoggedIn = true
                })
                .catch((err) => {
                    if (err?.status === 403) {
                        setIsConfirmed(false);
                    }});
        }
    }, []);

    return(
        <>
            {API.isLoggedIn && isConfirmed ? <Redirect to="/"/> : <LoginPage/>}
        </>
    );
};

export default IsLoggedInCheck;
